'use strict';

var CycleDetectionValidation = function CycleDetectionValidation() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, ele, attrs, ctrl) {
      ctrl.$parsers.unshift(function (value) {
        var valid = true;
        if (value) {
          valid = !scope.cycleDetected();
          ctrl.$setValidity('cycleDetected', valid);
        }
        return value;
      });
    }
  };
};
CycleDetectionValidation.$inject = [];
module.exports = CycleDetectionValidation;